import { Trans } from 'react-i18next';
import classnames from 'classnames';
import { Link } from '@Components/common';
import { Routes } from '@App/paths';
import styles from './Title.module.scss';

interface TitleProps {
  fund?: boolean;
  project?: boolean;
  id: number;
  name: string;
  organizationId?: number;
  organizationName: string;
  accessCode?: string | null;
}

export const Title = ({
  fund,
  project,
  id,
  name,
  organizationId,
  organizationName,
  accessCode,
}: TitleProps) => {
  const path = fund ? Routes.FUND_DETAILS(id, accessCode) : `/project/${id}`;
  return (
    <>
      <Link href={path} className={styles.actionName}>
        {name}
      </Link>
      <p className={classnames(styles.organizationName, project && styles.withLink)}>
        <Trans
          ns="common"
          i18nKey="featured_card.by"
          components={[
            <Link
              href={`/${fund ? 'funder' : 'group'}-profile/${organizationId}`}
              className={styles.organizationPageLink}
            />,
          ]}
          values={{ organizationName }}
        />
      </p>
    </>
  );
};
